import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import LoyaltyItem from './LoyaltyItem';
import Loader from '../../components/Loader';
import { Box } from '@material-ui/core';
import './LoyaltyLevels.sass';

const LoyaltyLevels = observer(() => {
    const { LoyaltyStore: store } = useStores();

    useEffect(() => {
        store.getLevels();
    }, [store]);

    return (
        <Box pb={10}>
            <div className="loyalty-levels">
                <div className="loyalty-levels__title">Уровни лояльности</div>
                <div className="loyalty-levels__container">
                    {store.loading && <Loader />}
                    {!store.loading && store.levels?.length ? (
                        <div className="loyalty-levels__row">
                            {store.levels.map(level => (
                                <LoyaltyItem key={level.id} userLevel={store.userLevelInfo?.level} data={level} />
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
        </Box>
    );
});

export default LoyaltyLevels;
